import { Component, h, Prop, Element } from '@stencil/core';
import { Heading } from './../heading.component';
export class H1Component {
  constructor() {
    /**
     * Determines the over-ride size of the heading - the symantic tag remains the same
     */
    this.styledAs = 'title1';
    /**
     * Determines the over-ride heading font
     */
    this.font = null;
    /**
     * Determines the over-ride heading font colour
     */
    this.appearance = 'default';
    /**
     * Determines the over-ride bottom margin size
     */
    this.bottomMargin = null;
  }
  render() {
    return (h(Heading, { host: this.host, type: "h1", styledAs: this.styledAs, font: this.font, appearance: this.appearance, bottomMargin: this.bottomMargin }));
  }
  static get is() { return "agl-ds-h1"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["./../heading.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["../heading.component.css"]
  }; }
  static get properties() { return {
    "styledAs": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "TitleType",
        "resolved": "\"title1\" | \"title2\" | \"title3\" | \"title4\" | \"title5\" | \"title6\"",
        "references": {
          "TitleType": {
            "location": "import",
            "path": "../../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride size of the heading - the symantic tag remains the same"
      },
      "attribute": "styled-as",
      "reflect": false,
      "defaultValue": "'title1'"
    },
    "font": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "FontType",
        "resolved": "\"fontfamily01\" | \"fontfamily02\"",
        "references": {
          "FontType": {
            "location": "import",
            "path": "../../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride heading font"
      },
      "attribute": "font",
      "reflect": false,
      "defaultValue": "null"
    },
    "appearance": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "Appearance",
        "resolved": "\"default\" | \"highlight\" | \"inverse\" | \"muted\" | \"secondary-highlight\"",
        "references": {
          "Appearance": {
            "location": "import",
            "path": "../../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride heading font colour"
      },
      "attribute": "appearance",
      "reflect": false,
      "defaultValue": "'default'"
    },
    "bottomMargin": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "BottomMargin",
        "resolved": "\"none\" | \"space00\" | \"space01\" | \"space02\" | \"space03\" | \"space04\" | \"space05\" | \"space06\"",
        "references": {
          "BottomMargin": {
            "location": "import",
            "path": "../../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride bottom margin size"
      },
      "attribute": "bottom-margin",
      "reflect": false,
      "defaultValue": "null"
    }
  }; }
  static get elementRef() { return "host"; }
}
